// extracted by css-extract-rspack-plugin
export default {"vendorAndCurrency":"VendorAndCurrency_vendorAndCurrency__LimU9","exchangeDisplay":"VendorAndCurrency_exchangeDisplay__0ld4H"};